import { z } from 'zod';
export const HealthCheckStatusSchema = z.enum(['ok', 'fail']);
export const LivenessResponseSchema = z.object({
    status: z.literal('ok'),
});
export const ReadinessCheckSchema = z.object({
    name: z.string(),
    status: HealthCheckStatusSchema,
    detail: z.string().optional(),
});
export const ReadinessResponseSchema = z.object({
    status: HealthCheckStatusSchema,
    checks: z.array(ReadinessCheckSchema),
});
//# sourceMappingURL=health.js.map